import SelectObject from "../assets/SelectObject";
import DadataApi from "../api/dadata"
import * as constants from "../assets/constants";
import {Avatar, Button, RichCell} from "@vkontakte/vkui";
import React from "react";
import {AdaptivityContext, userIsTradeChild} from "../assets/constants";
import {Icon20DeleteOutline, Icon20EditCircleFillBlue, Icon20ViewOutline, Icon24Dropdown} from "@vkontakte/icons";
import KlientsItem from "../references/Klients/item";
import SalePoint from "../references/Klients/salePoint";

class SalePointSelectObject extends SelectObject {

    types = constants.getSalePointsTypes()


    renderCreateForm() {
        const base_url = constants.DEBUG ? constants.base_url_stage : constants.base_url_prod
        return <SalePoint
            no_reload_klient
            current_user={this.props.current_user}
            base_url={base_url}
            item={this.state.current_object}
            change={this.editCurrentSalePoint}
            hideForm={() => this.closeList()}
            onCreate={(value) => {
                this.setState({current_object: value})
                window.postMessage({type: 'newSalePointCreated', value})
                window.postMessage('closeSelectObject' + this.guid)
            }}
        />
    }

    createAction() {
        super.createAction()

        const item = this.props.current_doc
        if (item) {
            const value = {
                //id: -1,
                klient_id: item.doc_data.klient && item.doc_data.klient.uid ? item.doc_data.klient.uid : null,
                klient: item.doc_data.klient && item.doc_data.klient.uid ? item.doc_data.klient.uid : {},
                mall_id: item.doc_data.mall ? item.doc_data.mall.uid : null,
                mall: item.doc_data.mall,
                comment: '', info: ''
            }
            this.setState({current_object: value})

            window.postMessage({
                type: 'setCurrentSalePoint',
                value

            })
        } else {
            this.setState({current_object: {}})
        }
    }

    editAction(value) {
        value.id = value.uid
        this.setState({current_object: value})

        window.postMessage({
            type: 'setCurrentSalePoint',
            value

        })

        this.setActiveModal(constants.MODAL_SELECT_LIST_ADD)
    }

    editCurrentSalePoint = (e, fieldName) => {
        const {current_object} = this.state
        ///console.log(e)
        if (e.unrestricted_value !== undefined) {
            current_object.dadata_object = e
            current_object.full_address = e.value
        } else {
            current_object[fieldName] = e.currentTarget.value
        }
        this.setState({current_object})
    }
    renderRow = (point, index, last_store_klients_id = null) => {
        const isTradeChild = userIsTradeChild(this.props.current_user, point.user_id)
        const images_url = this.props.base_url.replace("frontend/", '');


        let image_item = {
            hasImage: false,
            mainImage: images_url + constants.EMPTY_IMG,
            thumb: images_url + constants.EMPTY_IMG
        }
        if (Array.isArray(point.images)) {
            point.images.map((img) => {
                if (img.hasImage && !image_item.hasImage) {
                    image_item = img
                    image_item.hasImage = true
                }
            })
        }
        return <RichCell key={'select-obj-' + index} onClick={e => {
            if (e.target.nodeName != 'IMG' && e.target.nodeName != 'BUTTON') this.selectObject(index)
        }}
                         before={<a data-fancybox={'galleryIncomingDefective' + index}
                                    href={images_url + image_item.mainImage.replace('https:/l', 'https://l').replace(images_url, '')}>
                             {<Avatar mode="image" style={{borderRadius: '5%'}}
                                      size={AdaptivityContext.isMobile ? 70 : 100}
                                      src={image_item.thumb}/>}
                         </a>}
                         bottom={
                             <div style={{display: 'flex', flexDirection: 'column'}}>
                                 <span>{point.mall ? point.mall.title + ', ' : ''}
                                     {point.full_address}</span>
                                 <Button mode="outline"
                                         onClick={(e) => {
                                             e.stopPropagation()
                                             this.editAction(point)
                                         }} before={<Icon20EditCircleFillBlue/>}>Редактировать</Button>
                             </div>
                         }
                         subhead={point.klient ? point.klient.title : ''}
                         multiline
                         caption={
                             <span>Автор: <b>{point.author_name}</b> Изменено: {point.modified}</span>}
        >
            {this.types[point.type_]} {point.title}{point.trading_floor ? ', Зал: ' + point.trading_floor : ''}


        </RichCell>
    }

    renderButton = (styleDefault) => {

        const {current_object} = this.state

        return <div style={{display: 'flex'}}><Button size={this.props.size ? this.props.size : "l"}
                                                      disabled={this.props.disabled ?? false}
                                                      mode={this.props.mode ? this.props.mode : "primary"}
                                                      className={this.props.className}
                                                      after={<Icon24Dropdown/>}
                                                      style={{...styleDefault, ...this.props.style}}
                                                      onClick={() => this.showList()}
                                                      before={this.props.icon ? this.props.icon : ''}
                                                      selected={current_object.id != undefined}
                                                      expandable

        >
            {current_object.id != undefined || current_object.uid != undefined ?
                (`${this.types[current_object.type_]} ${current_object.title}  ${current_object.full_address} `) :
                (this.props.unselect_title ? this.props.unselect_title : 'Не указан')}
        </Button>
            {this.props.addon ?? ''}
        </div>
    }

}

export default SalePointSelectObject